/**
 * DetailMask component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Detail mask (dark fade).
 */
const DetailMask = styled.div`
  background: linear-gradient(
    226deg,
    rgba(0, 0, 0, 0) 24.12%,
    #000 52.25%,
    #202020 65.16%,
    #202020 76.61%
  );
  bottom: 0;
  height: ${1080 * Screen.widthRatio}px;
  left: 0;
  position: absolute;
  width: ${1920 * Screen.widthRatio}px;
  z-index: 1;
`;

export default withOpacity(DetailMask);
